import * as z from 'zod';
import { TrimmedString } from './common/processed';

export const RootCause = z.object({
  id: z.string().min(1),
  name: TrimmedString,
  description: TrimmedString,
  companyId: z.string().optional(),
  displayId: z.string(),
  status: z.string().optional(),
});

export type RootCause = z.infer<typeof RootCause>;
